// Add a click event listener to all elements with class "icon-with-text img"
const elements = document.querySelectorAll('.icon-with-text img');

// Get the message div
const messageDiv = document.getElementById('variantmessage');

// Define a variable to keep track of the number of selected images
let selectedImageCount = 0;
const f1 = [];
const f2 = [];
const total = [];
let turn = "f1";

const cookie_names = {'G&J Milk Chocolate Cookies':'Milk Chocolate',
'BOOM! Red Velvet Cookies':'BOOM! Red Velvet',
'Lemon White Chocolate Cookies':'Lemon White Chocolate',
'Ginger Molasses Cookies':'Ginger Molasses',
'Funfetti Celebration Cookies':'Funfetti Celebration',
'Brookies':'Brookie', 'Chocolate Sugar Cookies':'Chocolate Sugar'}

var imgElement = document.createElement("img");
// Set the src attribute of the img element to the image URL
imgElement.src = "https://gabiandjules.com/cdn/shop/files/Group_20_540x.svg"; // Replace with the actual image URL
imgElement.className = "img-placeholder";
var flavour_1 = document.createElement("img");
var flavour_2 = document.createElement("img");

var imgElement_second_placeholder = document.createElement("img");
// Set the src attribute of the img element to the image URL
imgElement_second_placeholder.src = "https://gabiandjules.com/cdn/shop/files/Group_20_540x.svg"; // Replace with the actual image URL
imgElement_second_placeholder.className = "img-second-placeholder";




function printFormValues() {
  var form = document.getElementById("AddToCartForm-8152321130750");
  var formData = new FormData(form);

  formData.forEach(function(value, key) {
    console.log(key + ": " + value);
  });
}

var productVariantTemplateDiv = document.getElementById("shopify-section-product-variant-template");
if (productVariantTemplateDiv) {


var main_image_container =  document.querySelector('div.image-wrap');
var main_image = document.createElement("img");
main_image.src = 'https://gabiandjules.com/cdn/shop/t/16/assets/cookies_tube.svg';
main_image.style.opacity = 1;
if (main_image_container){
  main_image_container.style.height = 'auto';
  main_image_container.style.padding = '0';
  main_image_container.querySelector('img.photoswipe__image').style.display='none';
  main_image_container.appendChild(main_image);
}

  
var forms = document.querySelectorAll('form.product-single__form');

// Loop through each form and attach the event listener
forms.forEach(function(form) {
  form.addEventListener('submit', function(event) {
   messageDiv.innerText = '';

    if (f1.length < 1 || f2.length < 1 ) {
       event.preventDefault();
      messageDiv.innerText = 'Please select 16 cookies up to 2 flavours.';
     return false;
    }
    this.submit = true;
    return true;
  });
});
  
  /* unselect all options initially
  var selectElement = document.querySelector('select.product-single__variants');
  selectElement.selectedIndex = -1;
  
  var radioButtons = document.querySelectorAll('input[type="radio"][name="Flavour 1"]');

radioButtons.forEach(function(radio) {
  radio.checked = false;
});

   var radioButtons = document.querySelectorAll('input[type="radio"][name="Flavour 2"]');

radioButtons.forEach(function(radio) {
  radio.checked = false;
}); */
  
  var productImageMainDiv = productVariantTemplateDiv.querySelector(".product-image-main");
  if (productImageMainDiv) {
    productImageMainDiv.appendChild(imgElement);
    productImageMainDiv.appendChild(imgElement_second_placeholder);
  }
} 



// Define the function to be executed when the element is clicked
function handleIconClick(event) {
  // You can access the clicked element using "event.target"
  const clickedElement = event.target;
  const childNode = clickedElement.parentNode.parentNode.querySelector('p');
  var optionsToSelect = [];



  // Check if more than two images are already selected
  if (selectedImageCount >= 2) {
    
    //messageDiv.innerText = 'You can only select up to two flavours.';
    //return;
  }
  if (f1.length < 1 && f2.length < 1 ) {
   const radioToSelect = document.querySelector('input[name="Flavour 1"][value="'+childNode.textContent.replace(/&/g, '')+'"]');
   addf1(clickedElement);
   radioToSelect.checked = true; 
   optionsToSelect.push(childNode.textContent.replace(/&/g, ''));
  
   
  }else if (f1.length == 1 && f2.length < 1 ) {
    const radioToSelect = document.querySelector('input[name="Flavour 2"][value="'+childNode.textContent.replace(/&/g, '')+'"]');
    addf2(clickedElement);
    radioToSelect.checked = true;
    optionsToSelect.push(childNode.textContent.replace(/&/g, '') + ' / '+ f1[0].parentNode.parentNode.querySelector('p').textContent.replace(/&/g, ''));
    
  
    
  }else{
    if (turn == "f1"){
      f1[0].style.opacity = '0.5';
      const radioToSelect = document.querySelector('input[name="Flavour 1"][value="'+childNode.textContent.replace(/&/g, '')+'"]');
      addf1(clickedElement);
      radioToSelect.checked = true;
      turn = "f2";
      
    }else if (turn == "f2"){
      f2[0].style.opacity = '0.5';  
      const radioToSelect = document.querySelector('input[name="Flavour 2"][value="'+childNode.textContent.replace(/&/g, '')+'"]');
      addf2(clickedElement);
      radioToSelect.checked = true;
      turn = "f1"; 
    }
    
    optionsToSelect.push(f1[0].parentNode.parentNode.querySelector('p').textContent.replace(/&/g, '') + ' / '+ f2[0].parentNode.parentNode.querySelector('p').textContent.replace(/&/g, ''));
  
  }


// select the variant id
   


  
    var select = document.querySelector('select[name="id"]');
    for (var i = 0; i < select.options.length; i++) {
       var option = select.options[i];
        var labelContainsAllStrings = optionsToSelect.every(function(label) {
        return option.textContent.includes(label);
    });
    
    if (labelContainsAllStrings) {
      option.selected = true;
    } else {
      option.selected = false;
    }
  }


  var chosen = document.querySelectorAll('span.chosen');
  
 
  chosen.forEach(function(element) {
    element.textContent = "";
  });  
  if ((f1.length >= 1 && f2.length < 1) || (f2.length >= 1 && f1.length < 1)  ) {
    var span_chosen = clickedElement.parentNode.parentNode.querySelector('span.chosen');
    span_chosen.textContent = "8 cookies selected";
  }else if (f1.length >= 1 && f2.length >= 1 && f1[0] === f2[0] ){
    var span_chosen = f1[0].parentNode.parentNode.querySelector('span.chosen')
    span_chosen.textContent = "16 cookies selected";
  }else if (f1.length >= 1 && f2.length >= 1 && f1[0] !== f2[0] ){
    var span_chosen_1 = f1[0].parentNode.parentNode.querySelector('span.chosen')
    span_chosen_1.textContent = "8 cookies selected";

    var span_chosen_2 = f2[0].parentNode.parentNode.querySelector('span.chosen')
    span_chosen_2.textContent = "8 cookies selected";
  }
  
  
  // Change the opacity of the clicked element to 1
  clickedElement.style.opacity = '1';

  // Increase the selectedImageCount
  selectedImageCount++;

  // You can also access attributes or perform other actions based on the clicked element
  // Example: const src = clickedElement.getAttribute('src');
 
}

// Attach the click event listener to each element
elements.forEach(function (element) {
  element.addEventListener('click', handleIconClick);
});


function addf1(value) {
  if (f1.length < 1) {
    // If the array has less than two values, simply add the new value
    f1.push(value); 
  } else {
    // If the array already has two values, remove the first one and add the new value
    f1.shift(); // Remove the first element
    f1.push(value); // Add the new value to the end
  }
  var imgElement = productImageMainDiv.querySelector('img.flavour_1');
  if (imgElement) {
    // Remove the <img> element from the DOM
    productImageMainDiv.removeChild(imgElement);
  } 
  flavour_1.src = value.src; // Replace with the actual image URL
  flavour_1.className = "flavour_1";
  productImageMainDiv.appendChild(flavour_1);
}


function addf2(value) {
  if (f2.length < 1) {
    // If the array has less than two values, simply add the new value
    f2.push(value);
  } else {
    // If the array already has two values, remove the first one and add the new value
    f2.shift(); // Remove the first element
    f2.push(value); // Add the new value to the end
  }
  var imgElement = productImageMainDiv.querySelector('img.flavour_2');

  if (imgElement) {
    // Remove the <img> element from the DOM
    productImageMainDiv.removeChild(imgElement);
  } 
  
  flavour_2.src = value.src; // Replace with the actual image URL
  flavour_2.className = "flavour_2";
  productImageMainDiv.appendChild(flavour_2);
}